import FiscaliteDeclaration from "./FiscaliteDeclaration";
import type { Declaration } from "../../utils/fiscalite";
import styles from "./FiscaliteDeclarationsList.module.css";

interface FiscaliteDeclarationsListProps {
  declarations: Declaration[];
}

export default function FiscaliteDeclarationsList({
  declarations,
}: FiscaliteDeclarationsListProps) {
  return (
    <div className={styles.list}>
      {declarations.map((decl) => (
        <FiscaliteDeclaration
          key={`${decl.profileId}-${decl.year}`}
          declaration={decl}
        />
      ))}
    </div>
  );
}
